import React from 'react';
import BookCard from './BookCard';
import BibleCard from './BibleCard';
import ThingCard from './ThingCard';

const ProductCard = ({ product, onLike, likedBooks, priority = false }) => {
  // Route to appropriate card component based on product type
  switch (product?.product_type) {
    case 'bible':
      return <BibleCard product={product} onLike={onLike} likedBooks={likedBooks} priority={priority} />;
    case 'thing':
      return <ThingCard product={product} onLike={onLike} likedBooks={likedBooks} priority={priority} />;
    case 'book':
    default:
      return <BookCard book={product} onLike={onLike} likedBooks={likedBooks} priority={priority} />;
  }
};

export default ProductCard;

